import React from "react";
import styled from "styled-components";
import { Container, } from "../../../Components/StyledComponents/StyledComponents";
// import WeaponFeature from "../Collection/WeaponFeature";
import BannerNftMarket from "./BannerNftMarket";
import NftArrivals from "./NftArrivals";
import NftMarketHomepage from "./NftMarketHomepage";

const Root = styled.div`
  padding-bottom: ${(p) => p.theme.spacing.sm};
`;


const NftMarket = (props) => {
  return (
    <Root style={{marginBottom:"60px"}}>
      <Container>
        <NftMarketHomepage {...props}/>

        <BannerNftMarket
          countdownTimestampMs={1735686000000}/>
        <NftArrivals {...props} />
        {/* <WeaponFeature /> */}
      </Container>
    </Root>
  );
};

export default NftMarket;
